import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import "./filtersViewStyles.css";
import "../../../styles/sprite.css";
import { useFocusable } from "../../../utils/Helpers";
import { useTranslation } from "react-i18next";
import { focusManager } from "../../../utils/Focus";
import { SelectFilterItemView } from "./SelectFilterItemView";
export var SelectFilterView = function (_a) {
    var options = _a.options, selected = _a.selected, filter = _a.filter, filterName = _a.filterName, onSelect = _a.onSelect, focusRaw = _a.focusRaw;
    var t = useTranslation().t;
    var _b = useState(false), popup = _b[0], setPopup = _b[1];
    var handleOpenFilter = useCallback(function () {
        focusManager.pushLayer({ groupName: filter, index: 0, isolate: true });
        setPopup(true);
    }, [filter]);
    var handleCloseFilter = useCallback(function () {
        setPopup(false);
        focusManager.popLayer();
    }, []);
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: handleOpenFilter,
        onKeyBack: handleCloseFilter,
    });
    var popupRef = useRef(null);
    useEffect(function () {
        if (popup && popupRef.current) {
            focusManager.registerGroup({
                name: filter,
                verticalContainer: popupRef.current,
            });
        }
    }, [popup, filter]);
    var handleOnSelect = useCallback(function (item) {
        // Apply immediately (grid refetches) but keep the popup open; closes on Back.
        onSelect(item);
    }, [onSelect]);
    var renderItem = useCallback(function (item, index) { return (React.createElement(SelectFilterItemView, { key: index + "-" + item.id, index: index, item: item, filter: filter, selected: selected, handleOnSelect: handleOnSelect, onClose: handleCloseFilter })); }, [selected, filter, handleOnSelect, handleCloseFilter]);
    var singleSelectedName = selected.length === 1
        ? (options.find(function (option) { return option.id === selected[0].id; }) || selected[0])
            .name
        : "";
    return (React.createElement("div", { ref: ref, className: "select-filter", tabIndex: 0 },
        React.createElement("p", { key: selected.length + "-" + filterName },
            selected.length === 1
                ? singleSelectedName
                : selected.length > 1
                    ? selected.length + " " + filterName + " " + t("filters.selected")
                    : filterName,
            " ",
            React.createElement("div", { className: "select-icon " + (popup ? "arrow-up" : "arrow-down") })),
        popup ? (React.createElement("span", { className: "popup" },
            React.createElement("ul", { ref: popupRef, id: filter + "-list", className: "select-options" }, options.map(function (item, index) { return renderItem(item, index); })))) : null));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/filter/SelectFilterView.tsx
// module id = 161
// module chunks = 1